export default {
    formList: [
        {
            entityField: "categoryName",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "分类名称",
        },
        {
            entityField: "pathCode",
            fieldType: "string",
            formatterContent: null,
            isRequired: 0,
            isShow: 1,
            searchId: null,
            extractId: null,
            setField: null,
            showField: "路径编码",
        },
        
    ],
};
